import * as React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Paper, Typography } from '@mui/material';
const PREFIX = 'ViewBillContentSection';

const classes = {
    title: `${PREFIX}title`
};

const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.title}`]: {
        color: theme.palette.titleTextColour
    }
}));

interface IProps {
    title?: string;
    subtitle?: string;
    bottomSpacing?: number;
    backgroundColor?: string;
}

export const ViewBillContentSection: React.FC<React.PropsWithChildren<React.PropsWithChildren<IProps>>> = ({
    title,
    subtitle,
    children,
    backgroundColor,
    bottomSpacing = 0
}) => (
    <StyledBox marginBottom={bottomSpacing}>
        <Paper sx={{ backgroundColor }} variant="outlined">
            <Box padding={1.5}>
                {title && (
                    <Typography align="center" variant="body1" className={classes.title}>
                        {title}
                    </Typography>
                )}
                {subtitle && (
                    <Typography display="block" align="center" variant="caption">
                        {subtitle}
                    </Typography>
                )}
                <Box marginTop={title ? 1.5 : 0}>{children}</Box>
            </Box>
        </Paper>
    </StyledBox>
);
